import { useState } from "react";

const useSelectExport = () => {
  const [contentType, setContentType] = useState("Objectives");
  const [year, setYear] = useState();

  const selectYear = (yearValue) => setYear(yearValue);
  const selectPill = (contentValue) => setContentType(contentValue);

  return { contentType, selectPill, year, selectYear, setYear };
};

export default useSelectExport;
